// PhaseList Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { WithDragSource as PhaseItem } from '../phase_item/phase_item.jsx'

class PhaseList extends Component {
  static get propTypes () {
    return {
      phases: PropTypes.array,
      columnOptions: PropTypes.array
    }
  }

  static get defaultProps () {
    return {
      phases: [],
      columnOptions: []
    }
  }

  render () {
    const { phases, columnOptions, ...others } = this.props

    return (
      <div className='phase-list'>
        {phases.map(phase => (
          <PhaseItem
            key={phase.id}
            phase={phase}
            columnOptions={columnOptions}
            showExpand={phases.length > 1}
            phaseAsString={JSON.stringify(phase)}
            showItems
            {...others}
          />
        ))}
      </div>
    )
  }
}

export default PhaseList
